<div class="mt-page">

  <!-- ============================================================
       1. HERO
       ============================================================ -->
  <section class="mt-hero">
    <div class="mt-hero-blob mt-hero-blob--1"></div>
    <div class="mt-hero-blob mt-hero-blob--2"></div>
    <div class="mt-container">
      <div class="mt-hero-inner">

        <div class="mt-hero-left">
          <div class="mt-hero-badge">
            <span class="mt-badge-pulse"></span>
            2026 Bookings Now Open
          </div>
          <h1 class="mt-hero-title">
            11+ Mock Tests<br>
            <em>Real Exam Practice</em>
          </h1>
          <p class="mt-hero-sub">8 centres across England · CSSE · GL · FSCE formats · Face to Face &amp; Online</p>
          <div class="mt-hero-actions">
            <button class="mt-btn-primary" (click)="scrollToCalendar()">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book a Session
            </button>
            <button class="mt-btn-ghost" (click)="downloadCalendar()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Schedule
            </button>
          </div>
          <div class="mt-hero-stats">
            <div class="mt-hstat"><strong>8</strong><span>Centres</span></div>
            <div class="mt-hstat-div"></div>
            <div class="mt-hstat"><strong>3</strong><span>Test Types</span></div>
            <div class="mt-hstat-div"></div>
            <div class="mt-hstat"><strong>10K+</strong><span>Students</span></div>
            <div class="mt-hstat-div"></div>
            <div class="mt-hstat"><strong>GL · CSSE · FSCE</strong><span>Boards</span></div>
          </div>
        </div>

        <!-- Right: Quick guide -->
        <div class="mt-hero-right">
          <div class="mt-hero-guide">
            <div class="mt-guide-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              How to Book in 3 Steps
            </div>
            <div class="mt-guide-steps">
              <div class="mt-gstep">
                <div class="mt-gstep-num">1</div>
                <div>
                  <div class="mt-gstep-label">Choose your centre &amp; date</div>
                  <div class="mt-gstep-sub">Filter by location, mode and exam board</div>
                </div>
              </div>
              <div class="mt-gstep">
                <div class="mt-gstep-num">2</div>
                <div>
                  <div class="mt-gstep-label">Select Face to Face or Online</div>
                  <div class="mt-gstep-sub">Use the Mode filter in the session schedule</div>
                </div>
              </div>
              <div class="mt-gstep">
                <div class="mt-gstep-num">3</div>
                <div>
                  <div class="mt-gstep-label">Click the gold Book button</div>
                  <div class="mt-gstep-sub">Takes 60 seconds to complete</div>
                </div>
              </div>
            </div>
            <button class="mt-guide-cta" (click)="scrollToCalendar()">
              Start Booking Now →
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       2. OFFERS STRIP
       ============================================================ -->
  <div class="mt-offers">
    <div class="mt-container">
      <div class="mt-offers-inner">
        <span class="mt-offers-pulse"></span>
        <span class="mt-offers-text">Special Offers on 11+ Mock Tests — <strong>Up to 50% off</strong></span>
        <a class="mt-offers-btn" [routerLink]="['/offer-free-resources']">Claim Offers →</a>
      </div>
    </div>
  </div>

  <!-- ============================================================
       3. TEST TYPE — single Mock Test card, full width
       (Mode toggle removed from here — now lives in filter bar)
       ============================================================ -->
  <section class="mt-types" id="test-types">
    <div class="mt-container">
      <div class="mt-section-hd">
        <p class="mt-eyebrow">What We Offer</p>
        <h2 class="mt-section-title">11+ Mock Test <span>Booking</span></h2>
        <p class="mt-section-sub">Full-length exam under real timed conditions. Use the filters below to choose your centre, exam board and mode.</p>
      </div>

      <!-- Full-width single card — informational only, no mode toggle -->
      <div class="mt-type-single">
        <div class="mt-type-card-wide">
          <div class="mt-type-card-wide-left">
            <div class="mt-type-icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <div class="mt-type-card-wide-text">
              <h3 class="mt-type-name">11+ Mock Test</h3>
              <p class="mt-type-when">March – September 2026</p>
              <p class="mt-type-desc">Full-length exam under real timed conditions. Includes RAR cohort report, doubt-clearing session, take-home papers and personalised feedback.</p>
            </div>
          </div>
          <!-- Highlights strip — replaces mode buttons -->
          <div class="mt-type-highlights">
            <div class="mt-type-hl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Face to Face &amp; Online available
            </div>
            <div class="mt-type-hl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              GL · CSSE · FSCE formats
            </div>
            <div class="mt-type-hl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              8 centres across England
            </div>
            <div class="mt-type-hl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              RAR report + doubt-clearing included
            </div>
            <button class="mt-type-scroll-btn" (click)="scrollToCalendar()">
              View All Sessions →
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       4. LOCATION QUICK-SELECT
       ============================================================ -->
  <section class="mt-centres">
    <div class="mt-container">
      <div class="mt-section-hd">
        <p class="mt-eyebrow">Pick Your Centre</p>
        <h2 class="mt-section-title">8 Centres <span>Across England</span></h2>
      </div>
      <div class="mt-centre-grid">
        <a class="mt-centre-card" [routerLink]="['/locations/redbridge-ilford-11plus-mocks']" (click)="filterByCentre('Ilford')">
          <span class="mt-centre-region">London</span>
          <span class="mt-centre-name">Ilford</span>
          <span class="mt-centre-boards">CSSE · FSCE · GL</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/essex-chelmsford-11plus-mocks']" (click)="filterByCentre('Chelmsford')">
          <span class="mt-centre-region">Essex</span>
          <span class="mt-centre-name">Chelmsford</span>
          <span class="mt-centre-boards">CSSE · FSCE</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/essex-basildon-11plus-mocks']" (click)="filterByCentre('Basildon')">
          <span class="mt-centre-region">Essex</span>
          <span class="mt-centre-name">Basildon</span>
          <span class="mt-centre-boards">CSSE · FSCE</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/essex-southend-on-sea-11plus-mocks']" (click)="filterByCentre('Southend')">
          <span class="mt-centre-region">Essex</span>
          <span class="mt-centre-name">Southend</span>
          <span class="mt-centre-boards">CSSE · FSCE</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/kent-bexley-11plus-mocks']" (click)="filterByCentre('Bexley')">
          <span class="mt-centre-region">Kent</span>
          <span class="mt-centre-name">Bexley</span>
          <span class="mt-centre-boards">GL Kent · GL Bexley</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/bucks-amersham-11plus-mocks']" (click)="filterByCentre('Amersham')">
          <span class="mt-centre-region">Bucks</span>
          <span class="mt-centre-name">Amersham</span>
          <span class="mt-centre-boards">GL QE · HBS · Bucks</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/bucks-milton-keynes-11plus-mocks']" (click)="filterByCentre('Milton Keynes')">
          <span class="mt-centre-region">Bucks</span>
          <span class="mt-centre-name">Milton Keynes</span>
          <span class="mt-centre-boards">GL QE · HBS · Bucks</span>
          <span class="mt-centre-arrow">→</span>
        </a>
        <a class="mt-centre-card" [routerLink]="['/locations/harrow-11plus-mocks']" (click)="filterByCentre('Harrow')">
          <span class="mt-centre-region">London</span>
          <span class="mt-centre-name">Harrow</span>
          <span class="mt-centre-boards">GL QE · HBS · Bucks</span>
          <span class="mt-centre-arrow">→</span>
        </a>
      </div>
    </div>
  </section>

  <!-- ============================================================
       5. CALENDAR — sticky filter bar + session cards
       ============================================================ -->

  <div class="mt-cal-heading" id="calendar-section">
    <div class="mt-container">
      <p class="mt-eyebrow" style="justify-content:center">Browse &amp; Book Sessions</p>
      <h2 class="mt-section-title" style="text-align:center">Mock Test <span>Schedule</span></h2>
      <p style="text-align:center;font-size:15px;color:var(--mt-tl);margin-top:8px">Use the filters to narrow results, then click the gold <strong style="color:var(--mt-g)">Book →</strong> button on any session</p>
    </div>
  </div>

  <!-- STICKY FILTER BAR -->
  <div class="mt-filterbar">

    <div class="mt-filterbar-main">
      <div class="mt-container">
        <div class="mt-filters-row">

          <!-- Search -->
          <div class="mt-fg mt-fg--search">
            <label class="mt-flabel">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
              Search
            </label>
            <input type="text" class="mt-finput mt-fsearch"
                   placeholder="Name, location, exam board..."
                   [(ngModel)]="filters.search" (input)="setFilter()" />
          </div>

          <!-- Centre -->
          <div class="mt-fg">
            <label class="mt-flabel">Centre</label>
            <select class="mt-fselect" [(ngModel)]="filters.center" (change)="setFilter()">
              <option [ngValue]="null">Any Centre</option>
              <option *ngFor="let l of centers" [ngValue]="l">{{ l }}</option>
            </select>
          </div>

          <!-- Board -->
          <div class="mt-fg">
            <label class="mt-flabel">Exam Board</label>
            <select class="mt-fselect" [(ngModel)]="filters.pattern" (change)="setFilter()">
              <option [ngValue]="null">All Boards</option>
              <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
            </select>
          </div>

          <!-- Mode toggle — moved here from the type card -->
          <div class="mt-fg mt-fg--mode">
            <label class="mt-flabel">Mode</label>
            <div class="mt-mode-toggle">
              <button class="mt-mode-toggle-btn mt-mode-toggle-btn--f2f"
                      [class.mt-mode-toggle-btn--active]="filters.mode === 'Classroom Session'"
                      (click)="setMode('Classroom Session')">
                <span class="mt-mode-dot-sm"></span>
                Face to Face
              </button>
              <button class="mt-mode-toggle-btn mt-mode-toggle-btn--online"
                      [class.mt-mode-toggle-btn--active]="filters.mode === 'Online Session'"
                      (click)="setMode('Online Session')">
                <span class="mt-mode-dot-sm"></span>
                Online
              </button>
              <button class="mt-mode-toggle-btn mt-mode-toggle-btn--all"
                      [class.mt-mode-toggle-btn--active]="!filters.mode"
                      (click)="setMode(null)">
                All
              </button>
            </div>
          </div>

          <!-- Reset -->
          <button class="mt-freset" (click)="resetAllFilters()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Reset
          </button>

          <!-- Offers -->
          <a class="mt-foffers" [routerLink]="['/offer-free-resources']">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><path d="M12 22V7"/></svg>
            Offers
          </a>

        </div>
      </div>
    </div>

    <!-- Active pills + count bar -->
    <div class="mt-filterbar-pills" *ngIf="filters.pattern || filters.mode || filters.center || filters.search">
      <div class="mt-container">
        <div class="mt-pills-row">
          <span class="mt-pills-label">Active filters:</span>
          <span class="mt-pill" *ngIf="filters.pattern">
            Board
            <button class="mt-pill-x" (click)="filters.pattern=null;setFilter()">✕</button>
          </span>
          <span class="mt-pill" *ngIf="filters.mode">
            {{ filters.mode === 'Online Session' ? 'Online' : 'Face to Face' }}
            <button class="mt-pill-x" (click)="setMode(null)">✕</button>
          </span>
          <span class="mt-pill" *ngIf="filters.center">
            {{ filters.center }}
            <button class="mt-pill-x" (click)="filters.center=null;setFilter()">✕</button>
          </span>
          <span class="mt-pill" *ngIf="filters.search">
            "{{ filters.search }}"
            <button class="mt-pill-x" (click)="filters.search='';setFilter()">✕</button>
          </span>
          <span class="mt-count">{{ testList?.length || 0 }} session{{ testList?.length !== 1 ? 's' : '' }} found</span>
        </div>
      </div>
    </div>

  </div>

  <!-- SESSION LIST -->
  <section class="mt-sessions">
    <div class="mt-container">

      <!-- Sort bar -->
      <div class="mt-sortbar">
        <span class="mt-sortbar-count" *ngIf="testList?.length > 0">
          Showing <strong>{{ testList.length }}</strong> session{{ testList.length !== 1 ? 's' : '' }}
        </span>
        <div class="mt-sortbar-right">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
          Sorted by date (earliest first)
        </div>
      </div>

      <!-- CARDS -->
      <ng-container *ngIf="testList && testList.length > 0; else mtEmpty">

        <div class="mt-scard"
             *ngFor="let t of testList"
             [class.mt-scard--today]="isRangeDate(t.test_date)">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t.all_location || t.location }}</span>

          <div class="mt-scard-date" [class.mt-scard-date--range]="isRangeDate(t.test_date)" [class.mt-scard-date--tbd]="!hasDate(t.test_date)">
            <ng-container *ngIf="hasDate(t.test_date); else noDate">
              <span class="mt-scard-from" *ngIf="isRangeDate(t.test_date)">From</span>
              <span class="mt-scard-day">{{ getDateDay(t.test_date) }}</span>
              <span class="mt-scard-mon">{{ getDateMon(t.test_date) }}</span>
              <span class="mt-scard-yr">{{ getDateYr(t.test_date) }}</span>
            </ng-container>
            <ng-template #noDate>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="opacity:.55"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="mt-scard-tbd">TBC</span>
            </ng-template>
          </div>

          <div class="mt-scard-info">
            <div class="mt-scard-top">
              <a class="mt-scard-cat" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
                {{ trimChar(t.category) }}
              </a>
              <span class="mt-scard-mode" [class.mt-scard-mode--online]="t.exam_type === 'Online Session'" [class.mt-scard-mode--f2f]="t.exam_type !== 'Online Session'">
                <span class="mt-mode-dot-sm"></span>
                {{ t.exam_type === 'Online Session' ? 'Online' : 'Face to Face' }}
              </span>
            </div>
            <a class="mt-scard-type" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ trimChar(t.type) }}</a>
            <a class="mt-scard-name" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a>
            <div class="mt-scard-loc" *ngIf="t.location || t.all_location">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {{ trimChar(t.all_location || t.location) }}
            </div>
          </div>

          <div class="mt-scard-price">
            <ng-container *ngIf="t.payment_method === 'Free'; else priced">
              <span class="mt-price-free">Free</span>
            </ng-container>
            <ng-template #priced>
              <span class="mt-price-val">£{{ t.test_fees }}</span>
              <span class="mt-price-lbl">per child</span>
            </ng-template>
          </div>

          <div class="mt-scard-book">
            <a class="mt-book-btn" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Now
            </a>
          </div>

        </div>

        <div class="mt-loadmore">
          <button class="mt-loadmore-btn" (click)="loadMore(true)">
            Load More Sessions
          </button>
        </div>

      </ng-container>

      <ng-template #mtEmpty>
        <div class="mt-empty">
          <div class="mt-empty-ico">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <h3 class="mt-empty-title">No sessions match your filters</h3>
          <p class="mt-empty-sub">Try widening your search or removing some filters</p>
          <button class="mt-empty-reset" (click)="resetAllFilters()">Clear All Filters</button>
        </div>
      </ng-template>

    </div>
  </section>

  <!-- ============================================================
       6. JOURNEY PATHWAY
       ============================================================ -->
  <div class="mt-pathway">
    <div class="mt-container">
      <p style="text-align:center;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;color:var(--mt-s);margin-bottom:16px">Recommended Preparation Pathway</p>
      <div class="mt-pathway-inner">
        <div class="mt-pstep">
          <div class="mt-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <div class="mt-pstep-text">
            <strong>Topic Tests</strong>
            <span>Oct – Feb · Build foundations</span>
          </div>
        </div>
        <div class="mt-parrow">→</div>
        <div class="mt-pstep">
          <div class="mt-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div class="mt-pstep-text">
            <strong>Sprints</strong>
            <span>Oct – Feb · Build speed</span>
          </div>
        </div>
        <div class="mt-parrow">→</div>
        <div class="mt-pstep">
          <div class="mt-pstep-ico">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          </div>
          <div class="mt-pstep-text">
            <strong>Full Mocks</strong>
            <span>Mar – Sep · Real conditions</span>
          </div>
        </div>
        <div class="mt-parrow">→</div>
        <div class="mt-pstep mt-pstep--goal">
          <div class="mt-pstep-ico mt-pstep-ico--gold">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>
          </div>
          <div class="mt-pstep-text">
            <strong>Grammar School</strong>
            <span>Sept 2026 · The goal!</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       7. BENEFITS
       ============================================================ -->
  <section class="mt-benefits">
    <div class="mt-container">
      <div class="mt-benefits-inner">
        <div class="mt-benefits-left">
          <p class="mt-eyebrow">Why Choose Us</p>
          <h2 class="mt-section-title">Mock Exams That <span>Make a Difference</span></h2>
          <div class="mt-benefits-grid">
            <div class="mt-benefit" *ngFor="let b of benefits">
              <div class="mt-benefit-ico">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <span>{{ b }}</span>
            </div>
          </div>
        </div>
        <div class="mt-benefits-img">
          <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1767888188/2149402736_moy8o0.jpg" alt="Happy student" />
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       8. WHAT'S INCLUDED
       ============================================================ -->
  <section class="mt-included">
    <div class="mt-container">
      <div class="mt-section-hd">
        <p class="mt-eyebrow">Comprehensive Support</p>
        <h2 class="mt-section-title">Everything <span>Included</span> in Every Mock</h2>
      </div>
      <div class="mt-included-inner">
        <div class="mt-features">
          <div class="mt-feature" *ngFor="let f of features">
            <div class="mt-feature-ico">
              <div [innerHTML]="f.icon"></div>
            </div>
            <div class="mt-feature-body">
              <div class="mt-feature-title">{{ f.title }}</div>
              <p class="mt-feature-text">{{ f.text }}</p>
            </div>
          </div>
        </div>
        <div class="mt-vis-card">
          <div class="mt-vis-ico">
            <svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" width="40" height="40"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <h3 class="mt-vis-title">Mock Test Package</h3>
          <p class="mt-vis-sub">Everything your child needs to succeed in one booking</p>
          <div class="mt-vis-stats">
            <div class="mt-vstat"><span class="mt-vstat-n">6+</span><span class="mt-vstat-l">Benefits</span></div>
            <div class="mt-vstat"><span class="mt-vstat-n">100%</span><span class="mt-vstat-l">Support</span></div>
            <div class="mt-vstat"><span class="mt-vstat-n">1:1</span><span class="mt-vstat-l">Guidance</span></div>
          </div>
          <button class="mt-vis-cta" (click)="scrollToCalendar()">Book Your Session →</button>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       9. TESTIMONIALS
       ============================================================ -->
  <section class="mt-testi">
    <div class="mt-container">
      <div class="mt-section-hd mt-section-hd--light">
        <p class="mt-eyebrow mt-eyebrow--light">10,000+ Happy Students</p>
        <h2 class="mt-section-title mt-section-title--light">What <span>Parents</span> Say</h2>
      </div>
      <div class="mt-testi-grid">
        <div class="mt-tcard" *ngFor="let t of testimonials">
          <div class="mt-tcard-quote">"</div>
          <p class="mt-tcard-text">{{ t.text }}</p>
          <div class="mt-tcard-name">— {{ t.name }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       10. FAQ
       ============================================================ -->
  <section class="mt-faq">
    <div class="mt-container">
      <div class="mt-section-hd">
        <p class="mt-eyebrow">Any Questions?</p>
        <h2 class="mt-section-title">Frequently <span>Asked</span></h2>
      </div>
      <div class="mt-faq-list">
        <div class="mt-faq-item" *ngFor="let f of faqs; let i = index" [class.mt-faq-item--open]="openFaq === i">
          <button class="mt-faq-q" (click)="toggleFaq(i)">
            {{ f.q }}
            <svg class="mt-faq-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="mt-faq-a">{{ f.a }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       11. CONTACT STRIP
       ============================================================ -->
  <div class="mt-contact">
    <div class="mt-container">
      <div class="mt-contact-inner">
        <p class="mt-contact-title">Still have questions? We're here to help.</p>
        <div class="mt-contact-links">
          <a href="tel:+447464772331" class="mt-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
            +44 7464 772331
          </a>
          <a href="mailto:academy@sehyog.co.uk" class="mt-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            academy@sehyog.co.uk
          </a>
        </div>
      </div>
    </div>
  </div>

</div>